import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fetchImageByName } from "../../utils/utility";

const useStyles = makeStyles((theme) => ({
  background: {
    height: "95vh",
    [theme.breakpoints.down("md")]: {
      height: "85vh",
      width: "55vw"
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
    position: "fixed",
    marginLeft: "60%",
    bottom: 0,
    zIndex: -1,
  },
}));

const PatientComponent = () => {
  const classes = useStyles();
  return (
    <img
      src={fetchImageByName("patientPortraitNew")}
      alt="Patient"
      className={classes.background}
    />
  );
};

export default PatientComponent;
